import { EyeIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import LibraryRequestKebabMenu from "./LibraryRequestKebabMenu";
import LibraryRequestMenuItem from "./LibraryRequestMenuItem";

const stopRowClick = (event) => event.stopPropagation();

export function LibraryRequestViewDetailsMenuItem({ path }) {
  const navigate = useNavigate();
  if (!path) return null;

  return (
    <LibraryRequestMenuItem
      onClick={(event) => {
        event.stopPropagation();
        navigate(path);
      }}
    >
      <EyeIcon className="w-[16px] h-[16px]" />
      <span>View Details</span>
    </LibraryRequestMenuItem>
  );
}

export default function LibraryRequestViewDetailsMenu({ path }) {
  if (!path) return null;

  return (
    <LibraryRequestKebabMenu onButtonClick={stopRowClick} widthClass="w-80">
      <LibraryRequestViewDetailsMenuItem path={path} />
    </LibraryRequestKebabMenu>
  );
}
